export const UNKNOW_ERROR_MESSAGE : string = 'Unknown error has happened.';
